import { DELETE, GET, PATCH, POST, PUT } from "../../axios/apiService";

export const getTeams = async ({ query, options }) => {
  const url = `${
    process.env.REACT_APP_API_BASE_URL
  }/api/v1/workspace-settings/teams${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const createTeam = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams`;
  return POST(url, data, options);
};

export const updateTeam = async ({ data, options, teamId }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}`;
  return PUT(url, data, options);
};

export const deleteTeam = async ({ teamId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}`;
  return DELETE(url, options);
};

export const deleteTeamMember = async ({ teamId, memberId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}/members/${memberId}`;
  return DELETE(url, options);
};

export const viewTeam = async ({ teamId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}`;
  return GET(url, options);
};

export const addMembersToTeam = async ({ data, teamId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}/members`;
  return POST(url, data, options);
};

export const deleteMembersToTeam = async ({ teamId, memberId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}/members/${memberId}`;
  return DELETE(url, options);
};

export const getProductAccessSettings = async ({ teamId, query, options }) => {
  const url = `${
    process.env.REACT_APP_API_BASE_URL
  }/api/v1/workspace-settings/teams/${teamId}/team-settings${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const updateTeamProductAccessSettings = async ({ data, options, teamId, productId }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}/team-settings/${productId}/limit`;
  return PUT(url, data, options);
};

export const updateTeamProductAccess = async ({ data, options, teamId, productId }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}/team-settings/${productId}/access`;
  return PATCH(url, data, options);
};

export const resetTeamProductAccessSettings = async ({ teamId, productId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}/team-settings/${productId}/limit`;
  return DELETE(url, options);
};

export const getTeamFeatureAccess = async ({ teamId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}/feature-access`;
  return GET(url, options);
};

export const updateTeamFeatureAccess = async ({ data, options, teamId, feature }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}/feature-access/${feature}`;
  return PATCH(url, data, options);
};

export const getTeamMembers = async ({ query, teamId, options }) => {
  const url = `${
    process.env.REACT_APP_API_BASE_URL
  }/api/v1/workspace-settings/teams/${teamId}/members${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const checkTeamMembersConflicts = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/check-member-conflicts`;
  return POST(url, data, options);
};

export const updateTeamMemberRole = async ({ data, teamId, userId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/teams/${teamId}/members/${userId}/role`;
  return PATCH(url, data, options);
};
